import { render, staticRenderFns } from "./shareDetail.vue?vue&type=template&id=05c68adb&scoped=true&"
import script from "./shareDetail.vue?vue&type=script&lang=js&"
export * from "./shareDetail.vue?vue&type=script&lang=js&"
import style0 from "./shareDetail.vue?vue&type=style&index=0&id=05c68adb&scoped=true&lang=less&"
import style1 from "./shareDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c68adb",
  null
  
)

export default component.exports